import Vue from 'vue'
import Router from 'vue-router'
import BankTransfer from '@/views/BankTransfer.vue'
import AlipayTransfer from '@/views/AlipayTransfer.vue'
import WalletTransfer from '@/views/WalletTransfer.vue'
import WechatTransfer from '@/views/WechatTransfer.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/BankTransfer/:merchantOrderNo',
      name: 'BankTransfer',
      component: BankTransfer
    },
    {
      path: '/AlipayTransfer/:merchantOrderNo',
      name: 'AlipayTransfer',
      component: AlipayTransfer
    },
    {
      path: '/WalletTransfer/:merchantOrderNo',
      name: 'WalletTransfer',
      component: WalletTransfer
    },
    {
      path: '/WechatTransfer/:merchantOrderNo',
      name: 'WechatTransfer',
      component: WechatTransfer
    }
  ]
})